import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const cloudbeds = defineConnector({
  identifier: "cloudbeds",
  name: "Cloudbeds",
  tagLine: "Hospitality management platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.cloudbeds\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Cloudbeds app",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Cloudbeds getting started guide](https://developers.cloudbeds.com/docs/get-started) and create an app in the Cloudbeds developer portal. Copy the client ID and client secret for the property management account you want to connect.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/cloudbeds/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Cloudbeds account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Cloudbeds account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://api.cloudbeds.com/api/v1.3/oauth",
    tokenEndpoint: () => "https://api.cloudbeds.com/api/v1.3/access_token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.cloudbeds.com/",
  },
});
